module.exports = __webpack_public_path__ + "static/media/Circle.7b98ef99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/Circle.svg
// module id = 55
// module chunks = 0